module.exports = __webpack_public_path__ + "img/x3.19131e26.jpg";